<template>
    <img src="@/assets/bg-1.svg" alt="Background Decoration" class="absolute xl:top-0 xl:right-0 lg:top-0 lg:right-0 md:top-0 md:right-0 z-10 w-full xl:w-auto lg:w-full md:w-full opacity-100 xl:block hidden">
    <section class="relative w-full flex flex-col-reverse xl:flex-col lg:flex-col items-start justify-between font-poppins bg-white mt-24 md:mt-16 lg:mt-28 xl:mt-0 sm:py-10 md:py-0 xl:py-20  md:pt-0 px-6 md:px-0 lg:px-10 xl:px-10 z-0 antialiased">
      <img src="@/assets/bg 4.svg" 
         alt="Background" 
         class="absolute inset-0 w-full h-full object-cover z-10 xl:hidden">
      <img src="@/assets/bg.svg" alt="Background" class="absolute bottom-0 right-0 z-0 w-full xl:w-1/3 lg:w-auto opacity-100">
      <img src="@/assets/elemen.svg" alt="" class="absolute top-30 left-0 z-0 xl:block hidden">
     
      <!-- Left Side: Text -->
      <div class="w-full xl:w-1/2 text-start px-6 md:px-12 xl:px-10 z-10 mb-10 py-10">
       
        <h2 class="text-2xl sm:text-4xl md:text-4xl xl:text-4xl font-semibold xl:text-gray-700 lg:text-white md:text-white text-white max-w-3xl">
          <span class="relative inline-block lg:pt-10 md:pt-20 pt-5">
            Contact Information
            <span class="absolute bottom-1 left-0 w-full  h-2 bg-[#18a0c7] opacity-30"></span>
          </span>
        </h2>
        <p class="xl:text-gray-800 lg:text-white md:text-white text-white xl:text-md lg:text-lg md:text-md text-sm  text-justify font-light antialiased leading-relaxed max-w-6xl mt-8">
          Got questions, ideas, or feedback? Reach out to us - we're here to listen, collaborate, and make things happen together!
        </p>
        <a href="https://wa.me/628111623222?text=Halo,%20saya%20tertarik%20dengan%20produk%20Phisoft.%20Saya%20ingin%20mencari%20tahu%20lebih%20lenjut%20tentang%20produk%20ini!" 
        target="_blank" rel="noopener noreferrer"
        class="mt-8 inline-flex items-center px-4 py-2 lg:px-4 lg:py-2 bg-[#186a85] text-white border-2 border-[#186a85] font-normal rounded-full shadow-xl hover:bg-white hover:text-[#186a85] transition-all duration-300 transform hover:scale-105 text-base md:text-base group">
        Chat with Us
        <span class="inline-block ml-2  transform group-hover:translate-x-1 transition-transform">→</span>
      </a>
      </div>
    </section>
  </template>